var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacketWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.75391L8.69904 8.41993V15.9694L16 12.2413V4.75391Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15498 6.77358L7.42524 8.45099V15.9073L0 12.2102L0.217476 4.75391L2.64038 5.99669L2.45437 6.02769V8.94808L4.19417 10.0044V6.95973L4.15498 6.77358Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10874 7.24022L5.31262 5.8111L12.4893 2.23828L15.3165 3.5742L8.10874 7.24022Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63495 5.06408C2.79612 4.56699 1.07495 3.56039 0.90097 3.51068L8.07767 0L10.9359 1.46019L3.63495 5.06408Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketWhite);
export default __webpack_public_path__ + "static/media/packet-white.9ab6e69a6296b27bda4986ab7274d095.svg";
export { ForwardRef as ReactComponent };